export function formatWhen(iso: string | null | undefined): string {
  if (!iso) return "";
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTime(iso: string | null | undefined): string {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
}

export function formatDuration(ms: number | null | undefined): string {
  if (!ms) return "";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} m ${String(s % 60).padStart(2, "0")} s`;
  return `${Math.floor(m / 60)} h ${String(m % 60).padStart(2, "0")} m`;
}

/** A wait set in whole seconds, in words: "2 minutes", "90 seconds". */
export function formatWait(seconds: number): string {
  if (seconds >= 60 && seconds % 60 === 0) {
    const m = seconds / 60;
    return m === 1 ? "1 minute" : `${m} minutes`;
  }
  return seconds === 1 ? "1 second" : `${seconds} seconds`;
}

/** At least 2 decimals, up to 4: prices like 0.158 and fees like 0.002 are real. */
export function money(value: number | null | undefined): string {
  if (value === null || value === undefined) return "";
  return value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
    useGrouping: false,
  });
}

export function shortUuid(uuid: string | null | undefined): string {
  if (!uuid) return "";
  return `${uuid.slice(0, 8)}…${uuid.slice(-4)}`;
}

export const LIVE_RUN_STATES = new Set(["running", "cancelling", "halting", "pausing"]);
